// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column > div[data-v-9751bed2] {\n  padding: 0px 15px;\n}\n.column + .column[data-v-9751bed2] {\n  margin-top: 1rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
